import React from "react"

export const ContentSeparator = () => <div className="py-2" />
